import "./Dashboard.css";
import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

// Images
import dash from "../../images/dashboard.svg";
import pro from "../../images/profile-2user.svg";
import test from "../../images/test.svg";
import achi from "../../images/achievements1.svg";
import log_b from "../../images/logout-black.svg";
import dash_p from "../../images/dashboard-p.svg";
import pro_p from "../../images/profile-p.svg";
import test_p from "../../images/test-p.svg";
import achi_p from "../../images/achievements-p.svg";
import log_p from "../../images/logout-p.svg";
import { END_URL, IMG_URL, SITE_URL } from "../../config";
import DashboardMobile from "../DashboardMobile/DashboardMobile";
import ZoomModal from "../ZoomModal/ZoomModal";
import s1 from "../../images/side-menu1.svg";
import { useParams } from "react-router-dom";
import db from "../../images/db.svg";
import eb from "../../images/eb.svg";


function Dashboard({ globaltest }) {

  const eboookaccess = globaltest.user;

  const DashMenu = globaltest?.DashLink || [];

  globaltest = globaltest?.globalTest || [];


  const [tests, setTests] = useState([]);
  const navigate = useNavigate();
  const [activeMenu, setActiveMenu] = useState("Dashboard");
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const ref = useRef();
    const [isOpenMap, setIsOpenMap] = useState({}); 

  const [activeTestPath, setActiveTestPath] = useState(null);

  const url = localStorage.getItem("url");

  const { slug, test_slug } = useParams();

  useEffect(() => {
    if (location.pathname.startsWith("/profile")) {
      setActiveMenu("Profile");
    } else if (location.pathname.startsWith("/result")) {
      setActiveMenu("Dashboard");
    } else if (
      location.pathname === "/ques" ||
      tests.some((test) => test.pathname === location.pathname)
    ) {
      setActiveMenu("Tests");
      setIsOpen(true);
      setActiveTestPath(location.pathname);
    } else {
      setIsOpen(false);
    }
  }, [location.pathname, tests]);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  // Fetch tests on mount
  useEffect(() => {
    // axios
    //   .get(`${END_URL}/tests`)
    //   .then((response) => {
    // const updatedTests = response.data.map((test) => {
    //   try {
    //     const url = new URL(test.link, window.location.origin);
    //     return { ...test, pathname: url.pathname };
    //   } catch (e) {
    //     console.error("Invalid test link:", test.link);
    //     return { ...test, pathname: "" };
    //   }
    // });
    //     setTests(updatedTests);
    //   })
    //   .catch((error) => {
    //     console.error("Error fetching tests:", error);
    //   });

    const updatedTests = globaltest.map((test) => {

      try {
        const url = new URL(test.link, window.location.origin);
        return { ...test, pathname: url.pathname };
      } catch (e) {
        console.error("Invalid test link:", test.link);
        return { ...test, pathname: "" };
      }
    });

    setTests(updatedTests);


  }, [globaltest]);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  // const menuItems = [
  //     {
  //       id: "Dashboard",
  //       label: "Dashboard",
  //       img: db,
  //       activeImg: db,
  //       route: '/dashboard',
  //     },
  //     { id: "Profile", label: "Profile", img: pro_p, activeImg: pro_p, route: "/profile" },
  //     { id: "Tests", label: "Tests", img: test_p, activeImg: test_p },

  //     ...(eboookaccess
  //       ? [{
  //         id: "Ebook",
  //         label: "E-Book",
  //         img: eb,
  //         activeImg: eb,
  //         route: "/ebook",
  //       }]
  //       : []),

  //     { id: "Achievements", label: "Achievements", img: achi_p, activeImg: achi_p, route: "/achievements", },
  //     { id: "Logout", label: "Logout", img: log_p, activeImg: log_p },
  //   ];
  const menuItems = [
    ...DashMenu.map(menu => ({
      id: menu.menu_label,
      label: menu.menu_label,
      route: "/" + menu.menu_link,
      img: menu.menu_file ? `${IMG_URL}/d0/${menu.menu_file}` : test_p,
      activeImg:menu.menu_file ? `${IMG_URL}/d0/${menu.menu_file}` : test_p,
      sublinks: menu.sublinks ?? [] 
    })),
    {
      id: "Logout",
      label: "Logout",
      img: log_p,
      activeImg: log_p,
      route: "/logout",
      sublinks: [] 
    }
  ];

    // useEffect(() => {

    //   const newIsOpenMap = {};

    //   DashMenu.forEach((menu) => {
    //     if (menu?.sublinks?.some((sub) => location.pathname === `/${sub.link}`)) {
    //       newIsOpenMap[menu.id] = true;
    //       setActiveMenu(menu.id);
    //     }
    //   });
    //   setIsOpenMap(newIsOpenMap);

    // }, [location.pathname, DashMenu]);

      useEffect(() => {
        const found = DashMenu.some(
          (menu) =>
            menu?.sublinks?.some((sub) => location.pathname === `/${sub.link}`)
        );

        setIsOpen(found);
      }, [location.pathname, DashMenu]);

      console.log(DashMenu,'DashMenu');


  // const handleMenuClick = (menu) => {
  //   if (menu.id === "Logout") {
  //     handleLogout();
  //   } else {
  //     setActiveMenu(menu.id);
  //     if (menu.route) {
  //       navigate(menu.route);
  //     }
  //   }
  // };
  const handleMenuClick = (menu) => {

      if (menu.id === "Logout") {
        handleLogout();
      } 
      else if (menu.sublinks && menu.sublinks.length > 0) {
        setIsOpen((prev) => !prev); 
      }
      else {
        setActiveMenu(menu.id);
        setActiveTestPath(menu.route);
        setIsOpen(true);
        navigate(menu.route);
      }
  };

  const [isModalOpen, setModalOpen] = useState(false);

  console.log(eboookaccess, 'eboookaccess');

  console.log(location.pathname, 'location.pathnamelocation.pathnamelocation.pathname');

  return (
    <div className="dash-cont">
      <div className="dash-main">

        <ul className="dash-menus">
            {menuItems.map((menu) => (
              <li 
                key={menu.id} 
                className={menu.sublinks && menu.sublinks.length > 0 ? `drop-down1 ${isOpen ? "open" : ""}` : ""}
              >
                {/* Parent Menu Link */}
                <a
                  className={
                    (!menu.sublinks.length && location.pathname === menu.route) 
                      ? "active-test-item" 
                      : "menu1"
                  }
                  onClick={() => handleMenuClick(menu)}
                  style={{ color: activeMenu === menu.id ? "#88619a" : "#000" }}
                >
                  <span>
                    <img 
                      src={activeMenu === menu.id ? menu.activeImg : menu.img} 
                      alt={menu.label} 
                    />
                  </span>
                  {menu.label}
                </a>

                {menu.sublinks && menu.sublinks.length > 0 && isOpen && (
                  <ul>
                    {menu.sublinks.map((sub) => (
                      <li
                        key={sub.id}

                        // className={slug === sub.link ? "active-test-item" : ""}

                         className={
                            ( location.pathname === `/${sub.link}`) 
                              ? "active-test-item" 
                              : ""
                          }

                        onClick={() => {
                          setActiveMenu(menu.id);
                          setActiveTestPath(sub.link);
                          setIsOpen(true);
                          window.location.href = `${SITE_URL}/${sub.link}`;
                        }}
                      >
                        {sub.name}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>

        <div className="mobile-div">
          <DashboardMobile globaltest={globaltest} eboookaccess={eboookaccess} DashMenu={DashMenu} />
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
